// @flow

const normalizeStringForSearch = (str: any): string => String(str).trim().toLowerCase();

export default normalizeStringForSearch;
